export default (configurationGuid, pipToCart, designItemId, designId) => {
  const {
    nucleusCustomBlindsExperienceBaseUrl,
  } = window.pageContextJavascript;

  if (designItemId && designId) {
    return `${nucleusCustomBlindsExperienceBaseUrl}/custom-blinds/Configurator/EditMandI?configurationGuid=${configurationGuid}&designId=${designId}&itemId=${designItemId}`;
  }
  return `${nucleusCustomBlindsExperienceBaseUrl}/custom-blinds/Configurator/EditMandI?configurationGuid=${configurationGuid}`;
};
